"use strict";

var _classCallCheck = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FileReference = /*#__PURE__*/function () {
  _createClass(FileReference, [{
    key: "toJSON",
    value: function toJSON() {
      return Object.assign({}, new Object(this), {
        url: this.url,
        createdAt: this.createdAt.toISO()
      });
    }
  }]);

  function FileReference(_ref) {
    var id = _ref.id,
        mimetype = _ref.mimetype,
        size = _ref.size,
        originalName = _ref.originalName,
        createdAt = _ref.createdAt,
        url = _ref.url;

    _classCallCheck(this, FileReference);

    this.id = id;
    this.mimetype = mimetype;
    this.size = size;
    this.originalName = originalName;
    this.createdAt = createdAt;
    this.url = url;
  }

  return FileReference;
}();

exports.default = FileReference;